// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"6b8d24b6","977":"b7df3cbd"}[chunkId] + ".chunk.js";
};